<template>
    <section :class="setTabFixed  ? 'fixed-bottom' : ''">
        <hr class="divider shadow">
        <div class="d-flex flex-row justify-content-between pdt-10 pdb-10 pdl-16 pdr-16 footer-wrapper">
            <div class="t-headline5">
                <span class="t-body3">
                    {{$t("152")}}
                    <!-- 학습진행률 -->
                </span>
                <span v-if="basicData">{{parseInt(basicData.progression)}}%</span>
            </div>
            
            <div>
                <button class="mdc-button mdc-button--raised btn-red" v-if="tabType === 'ViewLesson' && nextLessonData" @click="learnLesson()">
                    {{$t("154")}}
                    <!-- 학습하기 -->
                </button>

                <button class="mdc-button mdc-button--raised btn-red" v-if="tabType === 'ViewExam' && examineeId" @click="takeFinalExam(examineeId)">
                    {{$t("193")}}
                    <!-- 시험보기 -->
                </button>

                <!-- <button class="mdc-button mdc-button--raised btn-red" v-if="tabType === 'ViewMission' && missionId" @click="takeMission(missionId)">
                    {{$t("209")}} -->
                    <!-- 미션제출 -->
                <!-- </button> -->
            </div>
        </div>
    </section>

</template>

<script>
/**
 * 나의 학습 상세 - footer 컴포넌트(my learning view - footer component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
export default {
    props: ['basicData', 'setTabFixed', 'tabType', 'nextLessonData', 'examineeId', 'missionId'],

    data() {
        return {
            nextProgressionId: null
        }
    },

    mounted() {
        this.nextProgressionId = this.nextLessonData ? this.nextLessonData.progressionId : null
    },

    methods: {
        // move learn lesson
        learnLesson() {
            //console.log('this.nextLessonData', this.nextLessonData);
            this.$router.push({
                name: 'LessonView',
                params: {
                    learnId: this.$route.params.learnId,
                    progressionId: this.nextLessonData.progressionId
                },
                query: this.$route.query
            })
            
        },

        // move take mission
        takeMission(missionId) {
            this.$router.push({
                name: 'LearnViewMission',
                params: {
                    assignmentId: missionId
                },
                query: this.$route.query
            })
        },

        // move take exam
        takeFinalExam(examineeId) {
            console.log('examineeId', examineeId);
            
            this.$router.push({
                name: 'FinalExamIntro',
                params: {
                    learnId: this.$route.params.learnId,
                    examineeId: examineeId
                },
                query: this.$route.query
            })
        }
    }
}
</script>